/**
 * @file: 层板编组，快捷调用
 * @author: xiaolong.huang@dmall.com
 */

import ShortCutKey from '../../interaction/shortcutkey/index';
import LayerGroup from '../../interaction/layerGroup';

function init(): void {
    ShortCutKey.on({
        keyName: 'ctrl+g',
        callback: (ev: JQuery.MouseDownEvent): void => {
            LayerGroup.groupAllSelect();
        }
    });

    ShortCutKey.on({
        keyName: 'command+g',
        callback: (ev: JQuery.MouseDownEvent): void => {
            LayerGroup.groupAllSelect();
        }
    });

    ShortCutKey.on({
        keyName: 'ctrl+shift+g',
        callback: (ev: JQuery.MouseDownEvent): void => {
            LayerGroup.groupDisperse();
        }
    });

    ShortCutKey.on({
        keyName: 'ctrl+shift+l',
        callback: (ev: JQuery.MouseDownEvent): void => {
            LayerGroup.groupDisperse('left');
        }
    });

    ShortCutKey.on({
        keyName: 'ctrl+shift+r',
        callback: (ev: JQuery.MouseDownEvent): void => {
            LayerGroup.groupDisperse('right');
        }
    });
}

export default {
    init
};
